import React from 'react';
import classNames from 'classnames';

// import rightArrow from '../../assets/images/RightArrow.svg';
// import './button.css';

export const Button = (props) => {
  return (
    <button onClick={props.onClick} className={classNames(props.styleButton)}>
      {props.text}
      {props.icon ? <img src={props.srcImage} alt="" /> : ''}
    </button>
  );
}



// WEBPACK FOOTER //
// ./src/screens/AssessmentReport/components/Button/Button.js